const translation: Record<string, string> = {
  "site.name": "黄桃视频",
  "site.slogan": "海量高清影视，免费随心看",
  "site.description": "黄桃视频是国内领先的免费高清在线视频平台",
  "nav.home": "首页",
  "nav.category": "分类",
  "nav.article": "文章资讯",
  "nav.about": "关于我们",
  "nav.search": "搜索影片...",
  "nav.appDownload": "APP下载",
  "hero.title": "海量高清影视",
  "hero.subtitle": "免费随心看",
  "hero.description": "黄桃视频——与樱花视频、糖豆视频、蘑菇视频同类的优质免费视频平台。超10万部影视资源，每日更新500+集，支持1080P至4K超清画质，不缓冲、不卡顿。",
  "hero.cta": "立即观看",
  "hero.appBtn": "下载APP",
  "home.featured": "热门推荐",
  "home.featuredDesc": "精选当下最热门的影视内容，热播好剧一网打尽",
  "home.categories": "视频分类",
  "home.categoriesDesc": "五大频道覆盖全品类内容，总有一款适合你的口味",
  "home.latestArticles": "最新资讯",
  "home.latestArticlesDesc": "了解黄桃视频最新动态与观影指南",
  "home.viewAll": "查看全部",
  "home.stats.users": "月活用户",
  "home.stats.resources": "影视资源",
  "home.stats.daily": "每日更新",
  "home.cta.title": "准备好开始观影了吗？",
  "home.cta.subtitle": "加入黄桃视频，畅享海量高清影视，全程免费无广告！",
  "home.cta.button": "立即进入",
  "category.all": "全部",
  "category.title": "视频分类",
  "category.browse": "浏览",
  "category.videos": "部影片",
  "category.noVideos": "暂无该分类的影片",
  "category.backToHome": "返回首页",
  "article.readMore": "阅读全文",
  "article.backToList": "返回列表",
  "article.publishedOn": "发布于",
  "article.by": "作者",
  "article.views": "次阅读",
  "article.relatedArticles": "相关文章",
  "article.noArticles": "暂无文章",
  "about.title": "关于黄桃视频",
  "about.brandIntro": "品牌介绍",
  "about.features": "核心优势",
  "about.milestones": "发展历程",
  "about.testimonials": "用户口碑",
  "about.contact": "联系我们",
  "about.stats": "平台数据",
  "footer.copyright": "© 2025 黄桃视频 huangtao.com 版权所有",
  "footer.disclaimer": "本站所有视频内容均来自互联网，仅供学习交流使用",
  "footer.quickLinks": "快速链接",
  "footer.platforms": "同类平台",
  "footer.contactUs": "联系我们",
  "scrollToTop": "返回顶部",
  "loading": "加载中...",
  "error": "加载失败，请稍后重试",
  "breadcrumb.home": "首页",
  "breadcrumb.category": "视频分类",
  "breadcrumb.article": "文章详情",
  "breadcrumb.about": "关于我们",
};

export default translation;